import { getMetrics } from "@/entities/Finance/Finance.queries";
import { AccountLabel } from "@/entities/Labeling/Account.model";
// import metrics from "./metrics.dummy.json";
import { useApiQuery } from "@/api";
import { longFormMoney } from "@/utils/misc/format";
import { PeriodKind } from "@/entities/Labeling/Account.model";
import { getLast12Months, getLastValue } from "@/utils/metrics/metricsUtils";

export function useMetrics() {
    const metrics = useApiQuery(getMetrics, {
        params: {
            labels: [
                AccountLabel.REVENUES,
                AccountLabel.EBITDA,
                AccountLabel.CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS,
                AccountLabel.ASSETS,
                AccountLabel.LIABILITIES,
            ],
            periodKind: PeriodKind.MONTHLY,
        },
    });
    const revenueValues = metrics.data?.find(
        (metric) => metric.info.derived.label === AccountLabel.REVENUES,
    )?.values;
    const ebitdaValues = metrics.data?.find(
        (metric) => metric.info.derived.label === AccountLabel.EBITDA,
    )?.values;

    const anualMetrics = useApiQuery(getMetrics, {
        params: {
            labels: [AccountLabel.NET_INCOME],
            periodKind: PeriodKind.YEARLY,
        },
    });
    const currentAssetsCashAndCashEquivalents = getLastValue(
        metrics.data?.find(
            (metric) =>
                metric.info.derived.label ===
                AccountLabel.CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS,
        )?.values,
    );

    const anualNetIncome = getLastValue(
        anualMetrics.data?.find(
            (metric) => metric.info.derived.label === AccountLabel.NET_INCOME,
        )?.values,
    );
    const assets = getLastValue(
        metrics.data?.find(
            (metric) => metric.info.derived.label === AccountLabel.ASSETS,
        )?.values,
    );
    const liabilities = getLastValue(
        metrics.data?.find(
            (metric) => metric.info.derived.label === AccountLabel.LIABILITIES,
        )?.values,
    );

    const revenue = revenueValues ? getLast12Months(revenueValues) : null;
    const ebitda = ebitdaValues ? getLast12Months(ebitdaValues) : null;

    return {
        revenue: longFormMoney(revenue),
        ebitda: longFormMoney(ebitda),
        revenueValues,
        ebitdaValues,
        currentAssetsCashAndCashEquivalents: longFormMoney(
            currentAssetsCashAndCashEquivalents,
        ),
        anualNetIncome: longFormMoney(anualNetIncome),
        assets: longFormMoney(assets),
        liabilities: longFormMoney(liabilities),
    };
}
